import React from 'react';
import adminApi from '../../api';
import { HyperdbForm } from '../../../hyperdb';
import { Form } from '../components';

export default HyperdbForm(Form, {
  customApi: adminApi,
  namespace: 'customer',
  mountedUrl: '/customers',
  titleNew: 'Create new customer',
  titleEdit: 'Edit customer',
  displayName: (object) => object.name,
  checkIsValid: (props) => {
    const customer = props.objectData;
    const isCustomerValid = !!customer.name && !!customer.registration_date && !!customer.domain_name && (!!props.objectData.id || !!props.objectData.client_id);
    let isUserValid = true;
    if (!customer.id) {
      const user = props.editedUser;
      isUserValid = user && !!user.name && !!user.email && !!user.login && !!user.password && user.password === user.confirm_password;
    }
    return isCustomerValid && isUserValid;
  },
  onSubmit: (props) => {
    if (!props.objectData.id) {
      const { confirm_password, ...userData } = props.editedUser;
      const customer = { ...props.objectData, user: userData };
      return props.api.customer.submitCreateForm(customer);
    } else {
      return props.api.customer.submitEditForm({ id: props.objectData.id, objectData: props.objectData });
    }
  }
});



// WEBPACK FOOTER //
// ./src/frontend/admin/customer/containers/Form.jsx